import { INFO_ASIDE_ID } from 'Constants/elements';
import * as Styled from './styles';

const InfoAside = (): JSX.Element => (
  <Styled.Aside id={INFO_ASIDE_ID}>
    <Styled.AteContainer />
  </Styled.Aside>
);

export default InfoAside;
